import axiosInstance from "./axiosInstance";

export const getWorkOrderDetails = async (token: string | null, workorder_id: number) => {
    const response = await axiosInstance.get(`/WorkOrders/GetWorkOrder/${workorder_id}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

    return response.data;
};


export const updateAssetStatusApi = async (
    token: string | null,
    asset_id: number,
    status: number,
    data:any 
) => {
    const response = await axiosInstance.post(
        `/Assets/UpdateAssetStatus/${asset_id}?status=${status}`,
        data, 
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
    return response.data;
};

export const createAssetApi = async (
    token: string | null,
    workorder_id: number,
    formData: {
        type_ID: number;
        category_ID: number;
        family_ID: number;
        useYearMakeModel: boolean;
        description: string;
        year: string;
        make: string;
        model: string;
        unitOfMeasure_ID: number;
        length: string;
        quantity: string;
        assetNumber: string;
        serialNumber: string;
        stockNumber: string;
        template: any;
        creationKey: string;
    }
) => {
    const response = await axiosInstance.put(`/Assets/CreateAsset?id=${workorder_id}`, {
        type_ID: formData.type_ID,
        category_ID: formData.category_ID,
        family_ID: formData.family_ID,
        useYearMakeModel: formData.useYearMakeModel,
        description: formData.description,
        year: formData.year,
        make: formData.make,
        model: formData.model,
        unitOfMeasure_ID: formData.unitOfMeasure_ID,
        length: formData.length,
        quantity: formData.quantity,
        assetNumber: formData.assetNumber,
        serialNumber: formData.serialNumber,
        stockNumber: formData.stockNumber,
        template: formData.template,
        creationKey: formData.creationKey
    },
        {
            timeout: 10000,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
    return response.data.asset;
};